import { call, put, takeEvery } from 'redux-saga/effects'

import { WalletActions } from 'primsell-shared-layer/features'

import { ContractReadService } from '../../../core/services/contractRead'

export function* getLoyaltyBalanceSaga(action: ReturnType<typeof WalletActions.getWalletLoyaltyBalanceRequest>) {
  try {
    const { contractAddress, address } = action.payload

    if (!contractAddress && !address) {
      throw Error
    }

    const balance = (yield call(
      [new ContractReadService(), 'getLoyaltyBalanceOf'],
      ...[contractAddress, address]
    )) as bigint

    yield put(WalletActions.getWalletLoyaltyBalanceSuccess({ balance: balance.toString() }))

    return balance
  } catch (error) {
    yield put(WalletActions.getWalletLoyaltyBalanceFailure({ error: (error as Error)?.message }))
  }
}

export function* getWalletBalanceSaga(action: ReturnType<typeof WalletActions.getWalletBalanceRequest>) {
  try {
    const { contractAddress, address, code } = action.payload

    if (!contractAddress && !address && !code) {
      throw Error
    }

    const balance = (yield call(
      [new ContractReadService(), 'getBalanceOf'],
      ...[contractAddress, address, code]
    )) as bigint

    yield put(WalletActions.getWalletBalanceSuccess({ balance: balance.toString() }))
  } catch (error) {
    yield put(WalletActions.getWalletBalanceFailure({ error: (error as Error)?.message }))
  }
}

function* walletSagas(): Generator {
  yield takeEvery(WalletActions.getWalletLoyaltyBalanceRequest, getLoyaltyBalanceSaga)
  yield takeEvery(WalletActions.getWalletBalanceRequest, getWalletBalanceSaga)
}

export { walletSagas }
